  <nav class="navbar navbar-expand-lg  headerutpl">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon" style="color:#fff">||||</span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <img class="img_utpl" src="https://www.utpl.edu.ec/sites/all/themes/utpl/logo.png">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            &nbsp;&nbsp;&nbsp;
          </li>  
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" href="#">Inicio</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="openBuild_libre()" style="font-style:italic;font-family: Georgia, 'Times New Roman', Times, serif;">Ir a la exposición virtual</a>
          </li>
          <!--
          <li class="nav-item">
            <a class="nav-link" (click)="openBuild()">Práctica libre</a>
          </li>
          -->
        </ul>
        <!--
        <form class="d-flex">
          <div class="btn-group dropstart">
            <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <img class="align-self-start mr-0 img-thumbnail rounded-circle size_img pl-3"
                  src="{{(profile?.photoURL) ? profile?.photoURL : '/assets/user.jfif'}}" alt="{{profile?.givenName}}">
              {{(profile?.givenName) ? profile?.givenName : 'Usuario'}} {{profile?.surname}}
            </button>
            <ul class="dropdown-menu">
              <li *ngIf="loginDisplay" class="pl-3 px-3"> {{profile?.userPrincipalName}}</li>
              <li *ngIf="!loginDisplay" disabled><a class="dropdown-item" (click)="login()"><i class="fas fa-sign-in-alt"> Ingresar</i></a></li>
              <li *ngIf="loginDisplay"><a class="dropdown-item" (click)="logout()"><i class="fas fa-address-card"> Salir</i></a></li>
            </ul>
          </div>
        </form>
        --> 
      </div>
    </div>
  </nav>